module.exports = "/images/avg-executions.dea9957421cd6042911de7f38d228fb0.svg";